/**
 * One shared run of an async job at a time.
 *
 * While a run is in flight, every further call gets THAT run's promise instead
 * of starting another; once it settles (either way) the next call starts fresh.
 *
 * Written for ensureOrderExists (contexts/index.tsx): a customer with no cart
 * who taps "add to cart" twice in quick succession — or an album add that
 * overlaps a calendar add — sent two createOrder requests, because both calls
 * saw no session yet. The later setOrderInfo won, and the first product sat in
 * an order the customer never checked out.
 */
export function singleFlight<T>(): (start: () => Promise<T>) => Promise<T> {
  let inFlight: Promise<T> | null = null;
  return (start) => {
    if (inFlight) return inFlight;
    const run = start().finally(() => {
      if (inFlight === run) inFlight = null;
    });
    inFlight = run;
    return run;
  };
}
